module.exports = ".loader{border:16px solid #f3f3f3;border-top:16px solid #3498db;border-radius:50%;width:80px;height:80px;animation:spin 2s linear infinite}@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/busy-loader/busy-loader.component.scss
// module id = 803
// module chunks = 9